import { render } from "./AposImageRelationshipEditor.vue?vue&type=template&id=05ed1ad2&scoped=true"
import script from "./AposImageRelationshipEditor.vue?vue&type=script&lang=js"
export * from "./AposImageRelationshipEditor.vue?vue&type=script&lang=js"

import "./AposImageRelationshipEditor.vue?vue&type=style&index=0&id=05ed1ad2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ed1ad2"],['__file',"image/ui/apos/components/AposImageRelationshipEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05ed1ad2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05ed1ad2', __exports__)) {
    api.reload('05ed1ad2', __exports__)
  }
  
  module.hot.accept("./AposImageRelationshipEditor.vue?vue&type=template&id=05ed1ad2&scoped=true", () => {
    api.rerender('05ed1ad2', render)
  })

}


export default __exports__